import { format } from "rut.js";
import { columns } from "../../../../dtos/columns";
import { numericFormatter } from "react-number-format";
import { RowConsultaOCM } from "../models/rowConsultaOCM";
import Conversiones from "../../../../utils/conversiones";

interface IProps {
    control: any;
}

export function useColumns({control} : IProps) {

    const COLUMNS: columns<RowConsultaOCM>[] = [
        {
            name: 'Linea negocio',
            selector: (row: RowConsultaOCM) => row.lineaNegocio,
            sortable: true,
            sortField: 'lineaNegocio',
            wrap: true,
            alling: 'left',
            export: true,
        },  
        {
            name: 'N° Operación',
            selector: (row: RowConsultaOCM) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        },       
        {
            name: 'Monto',
            selector: (row: RowConsultaOCM) => numericFormatter((Math.round(row.monto * 100)/100).toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "CLP " }),
            sortable: true,
            sortField: 'monto',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: "Fecha cobro",
            selector: (row: RowConsultaOCM) => Conversiones.fechaConHoraFormat(row.fechaCobro.toString()),
            sortable: true,
            sortField: 'fechaCobro',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: "Fecha pago",
            selector: (row: RowConsultaOCM) => Conversiones.fechaConHoraFormat((row.fechaPago ?? "").toString()),
            sortable: true,
            sortField: 'fechaPago',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'RUT cliente',
            selector: (row: RowConsultaOCM) => format(row.rutCliente!),
            sortable: true,
            sortField: 'rutCliente',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: "Observación",
            selector: (row: RowConsultaOCM) => row.observacion,
            sortable: true,
            sortField: 'observacion',
            wrap: true,
            export: true,
            alling: 'left',
        },
    ]

    return { COLUMNS };
}